export default __webpack_public_path__ + "static/media/focusAvatar.e3d261ba.svg";